<template>
    <main class="user-settings max-width-container">
        <h1 class="form-title">Settings</h1>
        <LoadingScreen v-if="!user" message="Loading your settings…" />
        <UserSettingsForm
            v-else
            :initial-values="user"
            validated
            :errors="errors"
            :success-message="settingsMessage"
            @submit-form="submitSettings"
        />
        <ChangePasswordForm
            ref="password"
            validated
            :errors="errors"
            :success-message="passwordMessage"
            @submit-form="changePassword"
        />
        <section class="actions">
            <router-link to="/">
                <Bttn class="outlined">Back</Bttn>
            </router-link>
        </section>
    </main>
</template>

<script>
import UserSettingsForm from "js/components/forms/UserSettingsForm";
import ChangePasswordForm from "js/components/forms/ChangePasswordForm";
import LoadingScreen from "js/components/common/LoadingScreen";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import { useUserStore } from "js/stores/userStore";

export default {
    name: "Settings",
    components: {
        UserSettingsForm,
        ChangePasswordForm,
        LoadingScreen,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            store: undefined,
            user: null,
            errors: {},
            settingsMessage: "",
            passwordMessage: "",
        };
    },
    async mounted() {
        this.store = useUserStore();
        await this.store.init();
        this.user = this.store.user;
    },
    methods: {
        submitSettings(data) {
            this.settingsMessage = "";
            this.store
                .edit("/api/user", data)
                .then((user) => {
                    this.store.update(user);
                    this.errors = {};
                    this.settingsMessage = "Settings saved";
                })
                .catch(this.handleResponseErrors);
        },
        changePassword(data) {
            this.passwordMessage = "";
            this.store
                .edit("/api/user", data)
                .then(() => {
                    this.errors = {};
                    this.passwordMessage = "Password changed";
                    this.$refs.password.clear();
                })
                .catch(this.handleResponseErrors);
        },
    },
};
</script>
